import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Formik } from 'formik';
import SiteForm from './SiteForm';
import { validationSiteForm } from '../../../utils/validations';
import ButtonBase from '../../Buttons/ButtonBase';
import './addSite.scss';
import { editSite, deleteSedeStore } from '../../../store/actions/UserAction';
import { connect } from 'react-redux';
import Popup from '../../Modal/PopUp';
import Snackbar from '../../../components/Snackbar';
import { isMobile } from 'react-device-detect';
import { showLoading, hideLoading } from '../../../store/actions/LoadingActions';

/* Scroll */
var Scroll = require('react-scroll');
//var scroll = Scroll.animateScroll;
var scroller = Scroll.scroller;
var ElementScroll = Scroll.Element;

const useStyles = makeStyles({
  //Modal

  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    display: 'flex',
    flexDirection: 'Column',
    width: 464,
    height: 'fit-content',
    borderRadius: 4,
    padding: '24px',
    boxShadow: '0 15px 15px 0 rgba(0, 40, 62, 0.3)',
    backgroundColor: 'white',
    '&:focus': {
      outline: 'none',
    },
    '@media (max-width: 580px)': {
      width: 328,
      height: 'auto',
    },
  },
  root: {
    width: 200,
    display: 'flex',
    alignItems: 'center',
  },
  close: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  infoWrapper: {
    padding: '32px 38px',
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    '@media (max-width: 580px)': {
      padding: 0,
    },
  },
  modalButtons: {
    width: 395,
    display: 'flex',
    //justifyContent: 'space-around',
    alignSelf: 'end',
    '@media (max-width: 580px)': {
      width: '100%',
    },
  },
  ButtonBase: {
    '@media (max-width: 580px)': {
      minWidth: 136,
    },
  },
  name: {
    fontSize: 22,
    color: '#10587f',
    textAlign: 'left',
    marginBottom: 16,
  },
  subname: {
    fontSize: 16,
    color: '#484848',
    textAlign: 'left',
    marginBottom: 16,
  },
  rating: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: 55,
  },
  starIcons: {
    fontSize: '2.5rem',
    color: '#ffc200',
  },
  emptyStar: {
    color: '#c1c1c1',
  },
  modalIcon: {
    fontSize: 32,
    padding: '0 8px',
  },
  cardIcon: {
    padding: '0 4px',
  },
});

function EditSite(props) {
  const [feedbackMessage, setFeedbackMessage] = useState({
    open: false,
    message: '',
    variant: 'success',
  });

  const {
    uid,
    evento,
    sede,
    id,
    arrSedeAll,
    editSite,
    deleteSedeStore,
    authClient,
    showLoading, 
    hideLoading,
  } = props;

  
  
  const classes = useStyles(props);

  const handleCloseFeedbackMessage = () => {
    setFeedbackMessage({
      open: false,
      message: '',
      variant: 'success',
    });
  };

  const handleSubmit = (values, { setSubmitting }) => {
    
    const arrayValues = Object.values(values)
    const fixValues = arrayValues.map(elem => {
      if (elem === 0) {
        elem =+ 1
      }
      return elem;
    })
    const boolValues = fixValues.every(elem => {
      return elem;
    });

    setSubmitting(false);
    showLoading();
    
    editSite(uid, id, values, arrSedeAll, boolValues)
      .then(res => {
        hideLoading();

        setTimeout(() => {
     
        resetTab();
        
        scroller.scrollTo('sitesForm', { smooth: true, offset: -64 });

        }, 2000);
        
        setFeedbackMessage({
          open: true,
          message: 'Tus cambios se han guardado con éxito',
          variant: 'success',
        });

      })
      .catch(error => {});
  };

  const formValues = {
    //flagEdit: 1,
    //item: id,
    estado: sede.estado,
    municipio: sede.municipio,
    direccion: sede.direccion,
    //phone: sede.phone,
  };

  const resetTab = () => {
    evento(false);
  };

  const deleteSede = item => {
    handleOpen();
  };

  /* Modal */
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  let fullName = sede.estado && sede.estado.concat(', ', sede.municipio);

  return (
    <>  

      <div className="addSite_marco">
        <Formik
          initialValues={formValues}
          validationSchema={validationSiteForm}
          onSubmit={handleSubmit}
          render={props => (
            <SiteForm
              evento={resetTab}
              {...props}
              handleDeleteSede={deleteSede}
              item={id}
              edit
            />
          )}
        />

        
      </div>

      <Snackbar
          open={feedbackMessage.open}
          message={feedbackMessage.message}
          variant={feedbackMessage.variant}
          handleClose={handleCloseFeedbackMessage}
          vertical="top"
          horizontal="right"
          snackbarTop={isMobile ? '70px' : '80px'}
        />
    </>
  );
}

const mapStateToProps = state => ({
  /*  formValues: state.formValues, */
  uid: state.authClient.uid,
  authClient: state.authClient,
  /* imgProfile: state.authClient.imgProfile, */
});

const mapDispatchToProps = dispatch => ({
  editSite: (uid, item, values, arrSedeAll, boolValues) =>
    dispatch(editSite(uid, item, values, arrSedeAll, boolValues)),
  deleteSedeStore: (uid, item, allSedes) =>
    dispatch(deleteSedeStore(uid, item, allSedes)),
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditSite);
